<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: String
})

const emit = defineEmits(['update:modelValue'])

const inputs = ref([])
const digits = ref(['', '', '', ''])

watch(() => props.modelValue, (newValue) => {
  if (newValue && newValue.length === 4) {
    digits.value = newValue.split('')
  }
})

function handleInput(e, index) {
  const value = e.target.value
  digits.value[index] = value
  
  if (value && index < 3) {
    inputs.value[index + 1].focus()
  }

  emit('update:modelValue', digits.value.join(''))
}

function handleKeydown(e, index) {
  if (e.key === 'Backspace' && !digits.value[index] && index > 0) {
    inputs.value[index - 1].focus()
  }
}

function handlePaste(e) {
  e.preventDefault()
  const pastedData = e.clipboardData.getData('text').slice(0, 4)
  if (pastedData.length === 4) {
    digits.value = pastedData.split('')
    emit('update:modelValue', digits.value.join(''))
    inputs.value[3].focus()
  }
}
</script>

<template>
  <div 
    class="flex gap-4" 
    @paste="handlePaste"
  >
    <input
      v-for="i in 4"
      :key="i"
      :ref="(el) => inputs[i - 1] = el"
      v-model="digits[i - 1]"
      type="text"
      maxlength="1"
      pattern="[0-9]"
      inputmode="numeric"
      class="
        w-12 h-14 text-center text-2xl font-semibold
        bg-transparent
        border-b-2 border-gray-300 
        focus:border-blue-500 focus:outline-none
        transition duration-200
      "
      @input="(e) => handleInput(e, i - 1)"
      @keydown="(e) => handleKeydown(e, i - 1)"
    >
  </div>
</template>